export const blogData = [
    {
        id: 1,
        title: 'Data Structures and algorithms using C++',
        description: 'Master core computer science concepts by mastering data structures, algorithms & problem solving using C++.',
        date: 'Aug 7, 2022',
        image: 'https://imgs.search.brave.com/-xJKGrtSTsvJIJ7-Ax_wvwigwSnc18QxaaB3lcWF_wE/rs:fit:384:216:1/g:ce/aHR0cHM6Ly9tZWRp/YS50YWxlbnRiYXR0/bGUuaW4vRmlsZXMv/QzRVX0ltYWdlcy9D/NFVfQ09VUlNFU19J/TUFHRVMvQ09VUlNF/X0lNQUdFLzE4MC9E/U0EuanBn',
        url: 'https://www.udemy.com/course/cpp-data-structures-algorithms-prateek-narang/learn/lecture/26886488?start=0#overview'
    },
    {
        id: 2,
        title: 'Introduction To C++(Complete Tutorial)',
        description: 'This course will give you a comprehensive introduction to modern C++ with C++20. You will go from being a beginner to an advanced user..',
        date: 'Aug 11, 2022',
        image: 'https://www.freecodecamp.org/news/content/images/size/w2000/2022/02/cpp31.png',
        url: 'https://www.freecodecamp.org/news/learn-c-with-free-31-hour-course/'
    },
    {
        id: 3,
        title: 'How to Get a Job in Product Based Companies?',
        description: 'Here are some basic ways to lay off the Radar',
        date: 'Aug 14, 2022',
        image: 'https://media.geeksforgeeks.org/wp-content/uploads/20190823120241/How-to-get-Placed-in-Product-Based-Companies.png',
        url: 'https://www.geeksforgeeks.org/how-to-get-a-job-in-product-based-companies/'
    },
    {
        id: 4,
        title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
        description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
        date: 'Sep 17, 2020',
        image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
        url: ''
    },
    {
        id: 5,
        title: 'NeetCode A better way to prepare for coding interviews.',
        description: 'Organized study plans.etailed video explanations.Code solutions for Python, Java, JavaScript and C++.  Public Discord community with over 14,000 members. Sign in to save your progress..',
        date: 'Oct 1, 2020',
        image: 'https://imgs.search.brave.com/1lYFyG4R2gohyaBs8gPi6shnyy5aLK2QHh5m7sizpVA/rs:fit:972:225:1/g:ce/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5k/R1lXYnhmMktid2Mt/eDUtaDdNNTJ3SGFE/biZwaWQ9QXBp',
        url: 'https://neetcode.io/'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/